import { connect } from "react-redux";
import TicketSearchPage from "../components/TicketSearchPage";
import * as actionsAuth from "../../../_actions/auth";
import * as actionsTicket from "../../../_actions/ticket";

const mapStateToProps = ({ Misc, Ticket }) => ({
    //Ticket
    ticketSearchData: Ticket.search,
    ticketSearching: Ticket.searching.loading,
    ticketSearchingData: Ticket.searching.data,
    ticketSearchingError: Ticket.searching.err,

    //Misc
    language: Misc.Settings.language,
    authToken: Misc.Auth.token,
    authTokenLoading: Misc.Auth.fetching.loading,
    authTokenFetchingError: Misc.Auth.fetching.err
});

const mapDispatchToProps = dispatch => ({
    searchTicket: (ticketNumber, emailAddress) => {
        dispatch(actionsTicket.searchTicket(ticketNumber, emailAddress));
    },
    setAuthToken: token => {
        dispatch(actionsAuth.setAuthToken(token));
    },
    resetTicket: () => {
        dispatch(actionsTicket.resetTicket());
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(TicketSearchPage);
